export default __webpack_public_path__ + "static/media/stakeholder-map-template.7ae07e24.pptx";